import { render, staticRenderFns } from "./MlColumn.vue?vue&type=template&id=aa34a9f4&scoped=true&"
import script from "./MlColumn.vue?vue&type=script&lang=js&"
export * from "./MlColumn.vue?vue&type=script&lang=js&"
import style0 from "./MlColumn.vue?vue&type=style&index=0&id=aa34a9f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa34a9f4",
  null
  
)

export default component.exports